import React, {useEffect} from 'react'

// Hooks

import GetStatesByCountry from '../../../../hooks/GetStatesByCountry';

// Components

import DropDownInput from '../../../UI/FormInput/DropDownInput';

// Utilities

import { formatDropDownOptions } from '../../../../utilities/helper-functions';

export default function JobClientAddressFields({dropDownOptions, formik, i}) {
    const { getStatesIsLoading, getStatesError, states, handleGetStatesByCountry } = GetStatesByCountry();

    // Get the States by Country

    useEffect(() => {
        if (formik.values?.jobReferences?.negocioPropio?.businessClients[i]?.pais === '0') {
            handleGetStatesByCountry(formik.values?.jobReferences?.negocioPropio?.businessClients[i]?.pais);
        }
    }, [handleGetStatesByCountry, formik.values?.jobReferences?.negocioPropio?.businessClients[i]?.pais])

    return (
        <>
            <DropDownInput
                formik={formik}
                fieldName={`jobReferences.negocioPropio.businessClients.${i}.pais`}
                label={'País'}
                options={formatDropDownOptions(dropDownOptions?.data?.countries)}
                isRequired={true}
            />

            {formik.values?.jobReferences?.negocioPropio?.businessClients[i]?.pais === '0' &&
            <DropDownInput
                formik={formik}
                fieldName={`jobReferences.negocioPropio.businessClients.${i}.entidad`}
                label={'Estado'}
                options={formatDropDownOptions(states)}
                isRequired={true}
                disabled={states?.length === 0 || getStatesIsLoading || getStatesError}
                loading={getStatesIsLoading}
            />}

        </>
    )
}